import React from 'react';
import { Card, Table } from 'antd';



const HandlerDetail:React.FC<any> = (props) => {
  const { data } = props || {};

  const columns = [
    {
      title: '操作时间',
      dataIndex: 'update_time',
      key: 'update_time',
    },
    {
      title: '操作人',
      dataIndex: 'uname',
      key: 'uname',
    },
    {
      title: '操作方式',
      dataIndex: 'op_event',
      key: 'op_event',
    },
    {
      title: '操作内容',
      dataIndex: 'description',
      key: 'description',
    },
  ];

  return (
    <>
      <Card title="操作记录" style={{ marginBottom: 20 }}>
        <Table columns={columns} dataSource={data?.operate_log || []} pagination={false} />
      </Card>
    </>
  );
}

export default HandlerDetail;
